module.exports = __webpack_public_path__ + "img/Group 11880.4b19bc45.png";